import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { UsersService } from './services/users.service';
import { DealerPlanService } from './services/service-plan.service';
import { DealerService } from './services/dealer.service';
import { CommonService } from './services/common.service';
import { TosService } from './services/tos.service';
import { ApiService } from './services/api.service';
import { BaseComponent } from '@app/directives/base-component';
import { VersionCheckService } from './services/version-check.service';

import { Modal } from './model/modal';

import { takeUntil, filter } from 'rxjs/operators';
import * as Sentry from "@sentry/angular";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent extends BaseComponent implements OnInit {

  loading_status = 'Loading...';
  is_loading = true;
  opacity = 1;

  m_notice: Modal = new Modal();
  tos: any;

  // Signal-based reactive properties
  me = this.usersService.me;
  dealerId = this.usersService.dealerId;
  isSubDealer = this.usersService.isSubDealer;

  ownerEmail: string;

  selectedPlan = null
  m_dealer_plan_modal: Modal = new Modal();
  m_dealer_plan_modal_v2: Modal = new Modal();

  hasAccessPermission = false;
  isBrowserCheck = true;
  isSubDealerEnable = true;
  isIpBlocked = false;

  params = <any>{};

  accessPerm$i = null;
  // hasAccessPermissionS1Env = true;

  constructor(
    private router: Router,
    private usersService: UsersService,
    private dealerPlanService: DealerPlanService,
    private dealerService: DealerService,
    private commonService: CommonService,
    private tosService: TosService,
    public apiService: ApiService,
    public versionCheckService: VersionCheckService
  ) {
    super();
    // console.log = logsService.notice;
    // console.error = logsService.err;

    // Router Navigation Breadcrumbs 설정
    this.setupNavigationBreadcrumbs();
  }

  ngOnInit() {
    const url = window.location.href;
    const params = this.commonService.getQueryParams(url.split('?')[1]);
    this.params = params;

    // Chrome 확인
    let isChrome = (/Chrome/.test(navigator.userAgent) || /iPhone/.test(navigator.userAgent)) && /Google Inc/.test(navigator.vendor);

    // Firefox 확인
    let isFirefox = (/Firefox/.test(navigator.userAgent) || /iPhone/.test(navigator.userAgent)) && /Gecko/.test(navigator.userAgent);

    // Safari 확인 (Safari 자체 또는 iPad에서 Safari 엔진을 사용하는 경우 포함)
    let isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent); // Safari이면서 Chrome이 아닌 경우
    let isWebKitBased = /AppleWebKit/.test(navigator.userAgent) && /iPad|iPhone|iPod/.test(navigator.userAgent); // iOS 장치에서 WebKit 사용

    // Safari 확인 추가 (iPad와 WebKit 기반 브라우저 포함)
    if (isWebKitBased || isSafari) {
      isSafari = true;
    }
    if (!isChrome && !isFirefox && !isSafari) {
      this.isBrowserCheck = false;
    }
    if (!this.isBrowserCheck) return;

    // User data already loaded by APP_INITIALIZER
    const me = this.me();

    if (!me) {
      console.error('User data not loaded. APP_INITIALIZER may have failed.');
      this.loading_status = 'Locating dealer information...';
      setTimeout(() => location.reload(), 5000);
      return;
    }

    // 앱이 정상 로드됨 → chunk error 리로드 guard 클리어
    sessionStorage.removeItem('last-chunk-error');
    sessionStorage.removeItem('last-chunk-error-time');

    this.opacity = 0;
    this.isIpBlocked = me.is_ip_blocked ?? false;

    // Sentry User Context 설정
    this.setUserContext();

    this.checkBlockStatus();
    // this.checkBlockSIEnv();

    if (me.type === 3) {
      this.fetchWCS();
    }

    setTimeout(() => {
      this.is_loading = false;
    }, 400);

    if (!me.is_accepted_tos && me.permissions?.has_admin_permission) {
      this.fetchTos();
    }

    const currentDealerId = this.dealerId();
    if (currentDealerId) {
      this.dealerService.getDealerInfo(currentDealerId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(dealerInfo => {
          const dealer = dealerInfo[0];
          this.ownerEmail = dealer?.email ?? dealer?.company_email;
          this.dealerService.getCurrencyList(currentDealerId, 'json', 'v1.2')
            .pipe(takeUntil(this.destroy$))
            .subscribe(res => {
              const currency = res.filter(c => c.currency_id === dealer?.currency_id)[0];
              if (currency) {
                // Update me signal with currency data
                this.usersService.updateMe({
                  currency: currency.currency,
                  currency_id: currency.currency_id,
                  currency_symbol: currency.symbol
                });
              }
            });
        });
      this.fetchDealerPlan();
    }
  }


  fetchTos() {
    if (this.params['dealer_id']) return;
    // if (!this.hasAccessPermissionS1Env) return;
    const dealerId = this.dealerId();
    if (dealerId) {
      this.tosService.get(dealerId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(res => {
          this.m_notice['tos'] = res[0];
          this.tos = res[0];
          this.openNotice();
        });
    }
  }

  fetchDealerPlan() {
    const dealerId = this.dealerId();
    if (!dealerId) return;
    this.dealerPlanService.getDealerPlan(dealerId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(res => {
        if(res?.current_month_service_plan_type === 1) {
          const localKey = 'CHeKTUser_standard_dealer_notification';
          let notice = JSON.parse(localStorage.getItem(localKey));
          if(!notice) {
            return this.m_dealer_plan_modal_v2.open()
            // this.m_dealer_plan_modal.data['type'] = 'plan-description'
            // return this.m_dealer_plan_modal.open()
          }
        }
      }, err => {
          console.debug('Failed Get dealer plan', err)
          // this.commonService.showErrorToast(err, 'Failed Get dealer plan')
        })
  }

  fetchWCS() {
    const dealerId = this.dealerId();
    if (dealerId) {
      this.dealerService.getPartners(dealerId)
        .pipe(takeUntil(this.destroy$))
        .subscribe(res => {
          if (res.length !== 0) {
            this.dealerService.wcs = res[0];
          }
        }, err => {
          console.debug('fetchWCS err', err);
        });
    }
  }

  async fetchAccessPerm() {
    try {
      await this.usersService.refreshMe();
      this.opacity = 0;
      this.checkBlockStatus();
    } catch (err) {
      console.debug('fetchAccessPerm:>', err);
    }
  }

  checkBlockStatus() {
    const me = this.me();
    if (!me) return;

    // if(!me.is_activated) {
    //   this.hasAccessPermission = false
    //   return  // hard block : not now
    // }

    if (me.app_access_permissions?.has_access_dealer_app) {
      this.hasAccessPermission = true;
      return;  // common logic
    }
    if (!me.app_access_permissions?.has_access_dealer_app &&
      (me.app_access_permissions?.has_access_payment_page && me.permissions?.has_payment_permission)) {
      this.hasAccessPermission = true;
      return;  // soft block
      // true : payment 권한 있어야 payment 페이지 보여줄 수 있음
      // false : 권한 없으면 기존대로 볼 수 없도록 하기
    }
    this.hasAccessPermission = false;
    return;
  }

  // checkBlockSIEnv() {
  //   if (!window.location.hostname.includes('s1')) return;
  //   const me = this.me();
  //   this.hasAccessPermissionS1Env = me?.app_access_permissions?.has_access_s1_env ?? true;
  // }

  openNotice() {
    this.m_notice.data['title'] = 'Terms and Agreement';
    this.m_notice.open();
  }

  onCloseDealerPlanModal(event) {
    const dealerId = this.dealerId();
    if (dealerId) {
      this.dealerPlanService.getDealerPlan(dealerId)
        .pipe(takeUntil(this.destroy$))
        .subscribe();
    }
    this.saveLocalStorage(event);
  }

  showPlanDescriptionModal(event){
    this.m_dealer_plan_modal.data['type'] = 'plan-description'
    this.m_dealer_plan_modal.open()
    this.saveLocalStorage(event)
  }

  saveLocalStorage(isHiding){
    if(!isHiding) return
    const localKey = 'CHeKTUser_standard_dealer_notification';
    localStorage.setItem(localKey, JSON.stringify(true))
  }

  // Router Navigation Breadcrumbs 설정
  private setupNavigationBreadcrumbs() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        // Sentry Breadcrumb 추가
        Sentry.addBreadcrumb({
          type: 'navigation',
          category: 'navigation',
          message: `Navigated to ${event.urlAfterRedirects}`,
          level: 'info',
          data: {
            from: event.url,
            to: event.urlAfterRedirects,
          },
        });
      });
  }

  // Sentry User Context 설정
  private setUserContext() {
    const me = this.me();
    if (!me) return;

    // User 정보 설정
    Sentry.setUser({
      id: me.user_id?.toString() || 'unknown',
      email: me.email || undefined,
      username: `${me.firstname} ${me.lastname}` || me.company_name || 'anonymous',
    });

    // Global Tags 설정
    Sentry.setTags({
      dealer_id: me.dealer_id?.toString() || 'unknown',
      dealer_type: me.type?.toString() || 'unknown',  // 1: Unknown, 2: Main, 3: Sub
      is_admin: me.permissions?.has_admin_permission ? 'true' : 'false',
      is_activated: me.is_activated ? 'true' : 'false',
      has_payment_permission: me.permissions?.has_payment_permission ? 'true' : 'false',
    });

    // Context 추가 정보 (검색/필터링에 유용)
    Sentry.setContext('dealer_info', {
      company_name: me.company_name || 'N/A',
      dealer_id: me.dealer_id,
      dealer_type: me.type === 2 ? 'Main Dealer' : me.type === 3 ? 'Sub Dealer' : 'CS / SI',
      currency: me.currency || 'USD',
      currency_symbol: me.currency_symbol || '$',
    });

    Sentry.setContext('user_permissions', {
      has_admin_permission: me.permissions?.has_admin_permission ?? false,
      has_payment_permission: me.permissions?.has_payment_permission ?? false,
      has_access_dealer_app: me.app_access_permissions?.has_access_dealer_app ?? false,
      has_access_payment_page: me.app_access_permissions?.has_access_payment_page ?? false,
      has_access_s1_env: me.app_access_permissions?.has_access_s1_env ?? false,
      is_ip_blocked: me.is_ip_blocked ?? false,
    });

    // 디버깅 로그
    console.debug('✅ Sentry User Context updated', {
      user_id: me.user_id,
      dealer_id: me.dealer_id,
      dealer_type: me.type,
    });
  }
}
